import { render, staticRenderFns } from "./BindPhone.vue?vue&type=template&id=10ee7268&scoped=true"
import script from "./BindPhone.vue?vue&type=script&lang=js"
export * from "./BindPhone.vue?vue&type=script&lang=js"
import style0 from "./BindPhone.vue?vue&type=style&index=0&id=10ee7268&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../Users/a0000/Documents/Box-IM/box-im/im-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ee7268",
  null
  
)

export default component.exports